// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
// Disabling analytics for the time being. Turn this on to enable, as well as below
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: 'AIzaSyA1ikinz_lwjUCjspeIa0qfCRap5cHML1M',
    authDomain: 'zombie-homes.firebaseapp.com',
    databaseURL: 'https://zombie-homes-default-rtdb.firebaseio.com',
    projectId: 'zombie-homes',
    storageBucket: 'zombie-homes.appspot.com',
    messagingSenderId: '21101335295',
    appId: '1:21101335295:web:3dd09fedef35d48b55f2ca',
    measurementId: 'G-9KGG6W9KT4',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)

// Initialize Firebase Authentication and get a reference to the service
export { auth, db, storage }

// Turn this on and above to enable analytics
// const analytics = getAnalytics(app);
